<template>
	<div class="header-info">
		<div class="text-right account-info" :class="{ 'keep-bottom': onetimePurchase }">
			<strong>
				{{ email }}
			</strong>
		</div>

		<div v-if="!onetimePurchase">
			<div v-if="region !== 'global'" class="balance">
				<span>
					{{ region === 'tw' ? $t('n-point') : $t('checkout.current-balance') }}
					<strong><currency :value="$store.state.currentBalance.Total" :code="currency"></currency></strong
				></span>
			</div>
			<div v-else-if="balanceInfo.IsCombined" class="balance">
				<span
					>{{ $t('checkout.Combined') }} <strong>{{ $n(balanceInfo.Total) }} {{ currency }}</strong></span
				>
			</div>
			<div v-else class="balance">
				<span
					>{{ $t('checkout.Refundable') }}
					<strong>{{ $n(balanceInfo.Refundable) }} {{ currency }}</strong></span
				>
				<span
					>{{ $t('checkout.NonRefundable') }}
					<strong>{{ $n(balanceInfo.NonRefundable) }} {{ currency }}</strong></span
				>
			</div>
		</div>
	</div>
</template>

<script>
import currency from '../common/currency';

export default {
	name: 'AccountInfoGroup',
	components: {
		currency,
	},
	props: {
		title: {
			type: String,
			default: 'Account Info',
		},
		info: {
			type: String,
			default: 'Account Info',
		},
	},
	data() {
		return {
			tpaType: this.$store.state.userAccountType,
			tpaShow: false,
		};
	},
	computed: {
		email() {
			return this.$store.state.userEmail;
		},
		currency() {
			return this.$store.state.currency;
		},
		currentBalance() {
			return this.$n(this.$store.state.currentBalance.Total, 'currency', this.currency);
		},
		balanceInfo() {
			return this.$store.state.currentBalance;
		},
		onetimePurchase() {
			return this.$store.state.onetimePurchase;
		},
	},
};
</script>

<style lang="less" scoped>
.header-info {
	text-align: right;
	font-size: 14px;
	float: right;
	font-family: Arial, Helvetica Neue, Helvetica, sans-serif;

	.account-info {
		&.keep-bottom {
			margin-top: 25px;
		}
	}
}
.balance {
	font-size: 14px;
	font-weight: bold;
	margin-top: 10px;
	color: #666;
	span {
		display: inline-block;
		&:first-child {
			padding-right: 7px;
			:after {
				padding-left: 15px;
				color: #4c4c4c;
				content: '|\A0';
				font-size: 13px;
			}
		}
		&:last-child {
			:after {
				content: none;
			}
		}
	}
	strong {
		padding-left: 10px;
		color: #eda03b;
	}
}
.tpa {
	position: relative;
	.icon-tpa {
		position: absolute;
		top: -2px;
		left: -25px;
		width: 20px;
		height: 20px;
	}
}
@media (max-width: 1024px) {
	.header-info {
		.account-info {
			&.keep-bottom {
				margin-top: 20px;
			}
		}
	}
	#accountInfo {
		font-size: 12px;
		padding-top: 5px;
		&.balance {
			margin-left: 20px;
		}
		strong {
			font-size: 16px;
			padding-top: 4px;
		}
	}
}
@media (max-width: 600px) {
	.header-info {
		float: none;
		.account-info {
			&.keep-bottom {
				margin-top: 0;
			}
		}
	}
}
@media (max-width: 450px) {
	.header-info {
		margin-top: 10px;
		.text-right,
		.balance {
			text-align: left;
		}
		.tpa {
			left: 25px;
		}
		.balance {
			span {
				display: block;
				&:first-child {
					padding-right: 0;
					:after {
						content: none;
					}
				}
				strong {
					display: inline-block;
					min-width: 80px;
				}
			}
		}
	}
}
@media (max-width: 320px) {
	.header-info {
		#accountInfo {
			margin-left: 0;
			display: block;
		}
	}
}
</style>
